import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

const getFanClubInfo = (userId) => API.get(`/users/${userId}/fan-club/`);

const getFanClubUsers = (userId, page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/${userId}/fan-club/users/?${params}`);
};

const getMyFanClubInfo = () => API.get('/users/me/fan-club/');

const patchMyFanClubInfo = (data) => API.patch('/users/me/fan-club/', data);

const getFanClubTopUsers = (userId) =>
  API.get(`/users/${userId}/fan-club/top-users/`);

export default {
  getFanClubInfo,
  getFanClubUsers,
  getMyFanClubInfo,
  patchMyFanClubInfo,
  getFanClubTopUsers,
};



// WEBPACK FOOTER //
// ./src/app/apis/fan.js